import React, { useLayoutEffect } from 'react';
import styled from '@emotion/styled';
import { Heading, Text, Column, Button } from '@8base/boost';

import { Trans } from 'utils/translate';
import * as LINKS from 'config/links';

import mobileImage from 'images/Mobile.svg';

const Container = styled('div')`
  background-color: #FFF;
  display: flex;
  width: 36rem;
  position: fixed;
  left: 50%;
  top: 50%;
  flex-direction: column;
  transform: translate(-50%, -50%);
  text-align: center;
`;

const MobileImage = styled('img')`
  width: 100%;
`;

export const Mobile = () => {
  useLayoutEffect(() => {
    requestAnimationFrame(window.htmlLoader.hide);
  });

  return (
    <Container>
      <Column gap="lg" alignItems="center">
        <MobileImage src={ mobileImage } />
        <Heading type="h2">
          <Trans i18nKey="mobile.heading">
          The mobile version of 8base<br />is not available yet
          </Trans>
        </Heading>
        <Text>
          <Trans i18nKey="mobile.text">
          Please use 8base on a desktop browser for the<br />best experience
          </Trans>
        </Text>
        <Button tagName="a" href={ LINKS.LANDING_URL }>
          <Trans i18nKey="mobile.action">
          Back to 8base.com
          </Trans>
        </Button>
      </Column>
    </Container>
  );
};
